'use client';

import Button from '@/components/base/button/button';
import { useTranslations } from 'next-intl';

interface Props {
  onDismiss: () => void;
  onConfirm: () => void;
}

const ProductRemovalConfirmationTooltipContent = ({
  onDismiss,
  onConfirm,
}: Props) => {
  const t = useTranslations('common');
  const tc = useTranslations('checkout');

  return (
    <div className="flex flex-col gap-xs" data-testid="popover_remove_product">
      {tc('product.remove_text')}
      <div className="inline-flex gap-xxs">
        <Button
          variant="tertiary"
          inverted
          size="small"
          aria-label={t('cancel')}
          onClick={onDismiss}
          testId="popover_cancel_remove_product_btn"
        >
          {t('cancel')}
        </Button>
        <Button
          variant="tertiary"
          inverted
          size="small"
          aria-label={t('remove')}
          onClick={onConfirm}
          testId="popover_remove_product_btn"
        >
          {t('remove')}
        </Button>
      </div>
    </div>
  );
};

export default ProductRemovalConfirmationTooltipContent;
